<!--
 * @Author: your name
 * @Date: 2021-11-17 16:21:35
 * @LastEditTime: 2021-11-26 14:56:53
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /static-pc/src/layout/Header.vue
-->
<template>
  <el-header height='32px'>
    <el-row type='flex' class="header-layout" justify='end'>
      <el-breadcrumb separator='|'>
        <el-breadcrumb-item to='/article/list'>新闻资讯</el-breadcrumb-item>
        <el-breadcrumb-item to='/about/us'>关于我们</el-breadcrumb-item>
        <el-popover
          trigger='hover'
        >
          <div class="qr-wrapper">
            <img :src="require('@/assets/common/app_qr.png')" class="app-qr-image" alt="">
            <div>扫码下载药脉通APP</div>
          </div>
          <el-breadcrumb-item slot="reference">
            <i class="el-icon-mobile-phone"></i>
            <span class="link-text">APP下载</span>
          </el-breadcrumb-item>
        </el-popover>
      </el-breadcrumb>
    </el-row>
  </el-header>
</template>
<script>
export default {
  name: 'Header',
  data () {
    return {
      
    }
  }
}
</script>
<style lang="scss" scoped>
  .el-header ::v-deep{
    background: #f5f5f5;
    padding-top: 10px;
    .header-layout {
      max-width: 1280px;
      margin: 0 auto;
    }
    .el-breadcrumb__inner.is-link {
      color: #787878;
      font-weight: normal;
      &:hover {
        color: #198CFF;
      }
    }
  }
  .link-text {
    margin-left: 5px;
    cursor: pointer;
    color: #787878;
  }
  .qr-wrapper {
    padding:5px;
    text-align: center;
    .app-qr-image {
      margin-bottom: 10px;
    }
  }
</style>